import { FunctionMapper, KeyMapper, Omit } from '../core/CoreTypes';
import { RouteUrl } from '../core/RouteUrl';

/** Takes all keys from **Routes**, removing prototype, returning the remaining keys with a type of string for each */
type T6 = KeyMapper<Omit<typeof RoutesInternal, 'prototype'>, string>;

type T7 = FunctionMapper<Omit<typeof RoutesInternal, 'prototype'>, string>;

type T8 = T7 & { LINK: T6 };

class RoutesInternal {
  /* General */
  public static HOME() { return new RouteUrl('/'); }

  /* Dev */
  public static STYLE_GUIDE() { return new RouteUrl('/style-guide'); }
}

const generateRoutes = (): T8 => {
  const getOriginalURL = function (key: string): string {
    const RoutesNoAny = RoutesInternal as any;
    // If function, run it and assume RouteUrl as a return type. Else, check for string and return its result
    if (typeof RoutesNoAny[key] === 'function') {
      const obj: RouteUrl = RoutesNoAny[key]({});
      if (obj != null) {
        return obj.originalUrl;
      }
    } else if (typeof RoutesNoAny[key] === 'string') {
      return RoutesNoAny[key];
    }
    // Uh
    return '';
  };

  const getStringVariant = function (key: string) {
    const RoutesNoAny = RoutesInternal as any;
    if (typeof RoutesNoAny[key] === 'function') {
      return (...args: any[]) => {
        // Actually call the function, which will return a RouteUrl or a string
        let obj = RoutesNoAny[key](...args) as RouteUrl;
        if (obj != null) {
          return obj.toString();
        } else {
          throw new Error(`Non RouteUrl detected. Please use RouteUrl for this key: ${key}`);
        }
      };
    } else if (typeof RoutesNoAny[key] === 'string') {
      return (...args: any[]) => {
        return RoutesNoAny[key](...args) as string;
      };
    }
    // Not a function, so what do we do?
    return null;
  };

  // Keys to be removed. Object functions, prototype and where we are storing the rest
  const spareKeys = ['name', 'length', 'construct', 'prototype', 'LINK'];

  const keys = Object.getOwnPropertyNames(RoutesInternal) // Get all properties from our routes list
    .filter(x => !spareKeys.includes(x)); // Remove props that we don't use

  // Get the LINK representation. Useful for url matching, such as the sidenav/menu
  const routeLinks = keys
    .map(x => ({ [x]: getOriginalURL(x) }))
    .reduce((a, b) => ({ ...a, ...b })) as T6;

  const routeToStrings = keys
    .map(x => ({ [x]: getStringVariant(x) }))
    .reduce((a, b) => ({ ...a, ...b })) as T7;

  return { ...routeToStrings, LINK: routeLinks };
};

const RouteConfig = generateRoutes();
export default RouteConfig;
